"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyCreatePodcastV1StudioPodcastsPost = void 0;
var BodyCreatePodcastV1StudioPodcastsPost_1 = require("./BodyCreatePodcastV1StudioPodcastsPost");
Object.defineProperty(exports, "BodyCreatePodcastV1StudioPodcastsPost", { enumerable: true, get: function () { return BodyCreatePodcastV1StudioPodcastsPost_1.BodyCreatePodcastV1StudioPodcastsPost; } });
